import React, { ReactElement, useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import tw, { css } from 'twin.macro';

const MenuItemStyle = css`
  ${[
    tw`absolute left-0 flex justify-center w-screen origin-top-right bg-white divide-y divide-gray-100 z-[200]`,
    tw`max-w-full`,
    tw`md:block md:bottom-auto md:left-auto focus:outline-none`,
    tw`mt-2 text-sm rounded-md`,
    tw`ring-1 ring-black ring-opacity-5`,
  ]}
`;

const MenuItemHasIcon = css`
  ${tw`md:fixed md:top-1/2 md:left-1/2 bottom-0 md:translate-x-[-50%] md:translate-y-[-50%] md:w-auto md:h-auto`}
`;

type Props = {
  open?: boolean;
  onClose?: () => void;
  children: ReactElement;
};

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 1000,
  },
  content: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0, .8)',
    zIndex: '1000',
    overflowY: 'auto',
    borderRadius: 0,
    border: 'none',
  },
};

const ModalWrap = ({
  children,
  open = false,
  onClose = () => {},
}: Props): ReactElement => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(() => {
    setIsOpen(open);
  }, [open, setIsOpen]);

  function closeModal() {
    setIsOpen(false);
    onClose();
  }

  const initialFocusableElement = useRef(null);

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      ariaHideApp={false}
      onRequestClose={() => {
        closeModal();
      }}
    >
      <div
      // css={tw`fixed top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] inline-flex flex-col justify-center items-center max-w-[540px] w-[84%] min-w-contents pt-[60px] transition-all transform bg-white shadow-xl rounded-[12px]`}
      >
        <div
          ref={initialFocusableElement}
          css={[MenuItemStyle, MenuItemHasIcon]}
        >
          {React.cloneElement(children, {
            onClose: closeModal,
          })}
        </div>
      </div>
    </Modal>
  );
};

export default ModalWrap;
